import clsx from "clsx";
import { Check } from "@chef/icons/small";
import { intl } from "./CompetitionStatus.Intl";

interface CompetitionStatusProps {
  isRequirementMet: boolean;
  requiredCount: number;
  currentCount: number;
  children: React.ReactNode;
}

export const CompetitionStatus = ({
  isRequirementMet,
  requiredCount,
  currentCount,
  children,
}: CompetitionStatusProps) => {
  const currentCountDisplay = isRequirementMet ? requiredCount : currentCount;

  return (
    <div className="flex items-center gap-3 mt-3 mb-2">
      <div
        className={clsx(
          isRequirementMet ? "bg-informationBG" : "bg-grey-3",
          "w-5 h-5 text-secondary rounded-sm flex items-center justify-center",
        )}
      >
        {isRequirementMet && <Check />}
      </div>

      <div className="flex-auto w-4/5">{children}</div>
      <div className="flex justify-end flex-auto w-1/5">
        {currentCountDisplay} {intl.OF} {requiredCount}
      </div>
    </div>
  );
};
